var render, staticRenderFns
import script from "./MdoryBarChart.vue?vue&type=script&lang=js&"
export * from "./MdoryBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MdoryBarChart.vue"
export default component.exports